import { DateTime } from 'luxon';

import { isEndOfDay } from './date';

export const formatStart = (time: DateTime) => {
	if (!time.isValid) {
		return '';
	}

	if (time.hasSame(DateTime.now().startOf('day'), 'day')) {
		return 'Today';
	}

	if (time.hasSame(DateTime.now(), 'day')) {
		return `Today, ${time.toFormat('HH:mm')}`;
	}

	if (time.hasSame(DateTime.now().minus({ days: 1 }).startOf('day'), 'day')) {
		return `Yesterday`;
	}

	if (time.hasSame(DateTime.now().minus({ days: 1 }), 'day')) {
		return `Yesterday, ${time.toFormat('HH:mm')}`;
	}

	if (time.hasSame(time.startOf('day'), 'day') === false) {
		return `${time.toFormat('ccc, dd LLL')}`;
	}

	return `${time.toFormat('ccc, dd LLL')}, ${time.toFormat('HH:mm')}`;
};

export const formatEnd = (time: DateTime) => {
	if (!time.isValid) {
		return '';
	}

	if (time.hasSame(DateTime.now(), 'day')) {
		return `Today, ${time.toFormat('HH:mm')}`;
	}

	if (time.hasSame(DateTime.now().minus({ days: 1 }).endOf('day'), 'day')) {
		return `Yesterday`;
	}

	if (time.hasSame(DateTime.now().minus({ days: 1 }), 'day')) {
		return `Yesterday, ${time.toFormat('HH:mm')}`;
	}

	if (!isEndOfDay(time)) {
		return `${time.toFormat('ccc, dd LLL')}, ${time.toFormat('HH:mm')}`;
	}

	return `${time.toFormat('ccc, dd LLL')}`;
};

export default {
	formatStart,
	formatEnd,
};
